export enum CrudActions {
    Create,
    Edit,
    View
  }
  export enum CycleStatus {
    Draft = 1,
    Started = 2,
    UnderReview = 3,
    Completed = 4,
  }